module.exports = __webpack_public_path__ + "static/media/notification@3x.a65fe52f.png";